import { Device, DeviceId } from '@capacitor/device'
import { isPlatform } from '@ionic/vue'

class DeviceService {
    isNative (): boolean {
        return isPlatform('hybrid')
    }
    isWeb (): boolean {
        return !this.isNative()
    }
    async getId (): Promise<string> {
        if (this.isWeb()) return 'WWW'

        const deviceId: DeviceId = await Device.getId()
        return deviceId.identifier
    }
}

export const deviceService = new DeviceService()
